"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventPropertySchema = exports.eventDefinitionSchema = exports.trackerPropertiesSchema = exports.trackerConfigSchema = exports.clientDependenciesSchema = exports.eventPropertyTypes = exports.eventClasses = void 0;

var schema = _interopRequireWildcard(require("./common/schema"));

var _messages = require("./common/messages");

var _helpers = require("./common/helpers");

var eventClasses = ['activation', 'creation', 'error', 'exposure', 'funnel', 'interaction', 'none', 'signup', 'usage', 'view', 'warning'];
exports.eventClasses = eventClasses;
var eventPropertyTypes = ['boolean', 'string', 'number', 'array'];
/*
 *  Schema for createClient() function args
 */

exports.eventPropertyTypes = eventPropertyTypes;
var clientDependenciesSchema = schema.create('client dependency', _messages.configError, {
  clientName: {
    types: ['string'],
    default: 'custom'
  },
  getDebug: {
    types: ['function']
  },
  getEmail: {
    types: ['function']
  },
  getHubId: {
    types: ['function']
  },
  getHstc: {
    types: ['function']
  },
  getLang: {
    types: ['function']
  },
  getCurrentHref: {
    types: ['function'],
    default: function _default() {
      return (0, _helpers.safeGetOrDefault)(['window', 'location', 'href'], '');
    }
  },
  getReferrer: {
    types: ['function'],
    default: function _default() {
      return (0, _helpers.safeGetOrDefault)(['document', 'referrer'], '');
    }
  },
  getUserAgent: {
    types: ['function'],
    default: function _default() {
      return (0, _helpers.safeGetOrDefault)(['navigator', 'userAgent'], '');
    }
  },
  getScreenWidth: {
    types: ['function'],
    default: function _default() {
      return (0, _helpers.safeGetOrDefault)(['screen', 'width'], '');
    }
  },
  getScreenHeight: {
    types: ['function'],
    default: function _default() {
      return (0, _helpers.safeGetOrDefault)(['screen', 'height'], '');
    }
  },
  getWindowWidth: {
    types: ['function'],
    default: function _default() {
      return (0, _helpers.safeGetOrDefault)(['window', 'innerWidth'], '');
    }
  },
  getWindowHeight: {
    types: ['function'],
    default: function _default() {
      return (0, _helpers.safeGetOrDefault)(['window', 'innerHeight'], '');
    }
  },
  getTempStorage: {
    types: ['function']
  },
  setTempStorage: {
    types: ['function']
  },
  logMessage: {
    types: ['function'],
    default: function _default(msg) {
      if (typeof (0, _helpers.safeGetOrDefault)(['console', 'log'], '') === 'function') {
        console.log(msg);
      }
    }
  },
  logError: {
    types: ['function'],
    default: function _default(err) {
      if (typeof (0, _helpers.safeGetOrDefault)(['console', 'error'], '') === 'function') {
        console.error(err);
      }
    }
  },
  reportError: {
    types: ['function']
  },
  send: {
    types: ['function']
  }
});
/*
 *  Schema for createTracker() function args
 */

exports.clientDependenciesSchema = clientDependenciesSchema;
var trackerConfigSchema = schema.create('config option', _messages.configError, {
  events: {
    types: ['object']
  },
  properties: {
    types: ['object'],
    default: {}
  },
  debug: {
    types: ['boolean', 'function']
  },
  onError: {
    types: ['function']
  },
  onScheduled: {
    types: ['function'],
    default: function _default() {}
  },
  allowUnauthed: {
    types: ['boolean'],
    default: false
  },
  bypassPool: {
    types: ['boolean'],
    default: false
  },
  isBeforeUnload: {
    types: ['boolean'],
    default: false
  },
  isExternalHost: {
    types: ['boolean'],
    default: false
  },
  lastKnownEventProperties: {
    types: ['array'],
    default: []
  },
  preserveTrackerProperties: {
    types: ['boolean'],
    default: true
  }
});
/*
 *  Schema for tracker properties
 */

exports.trackerConfigSchema = trackerConfigSchema;
var trackerPropertiesSchema = schema.create('tracker properties', _messages.configError, {
  email: {
    types: ['string', 'function', 'object']
  },
  hubId: {
    types: ['number', 'function', 'object']
  },
  hstc: {
    types: ['string', 'function', 'object']
  },
  lang: {
    types: ['string', 'function', 'object']
  }
}, false);
/*
 *  Schema for events.yaml definitions
 */

exports.trackerPropertiesSchema = trackerPropertiesSchema;
var eventDefinitionSchema = schema.create('event property', _messages.configError, {
  name: {
    types: ['string']
  },
  namespace: {
    types: ['string'],
    default: ''
  },
  class: {
    types: ['string'],
    oneOf: eventClasses
  },
  version: {
    types: ['string'],
    default: 'v1'
  },
  properties: {
    types: ['object'],
    default: {}
  }
});
/*
 *  Schema for events.yaml event properties
 */

exports.eventDefinitionSchema = eventDefinitionSchema;
var eventPropertySchema = schema.create('event property', _messages.configError, {
  type: {
    types: ['string', 'array'],
    oneOf: eventPropertyTypes
  },
  isOptional: {
    types: ['boolean'],
    default: false
  }
});
exports.eventPropertySchema = eventPropertySchema;